<template>
  <div v-if="!isYoshinFuka" class="content">
    <section>
      <div class="page-btn-wrapper">
        <md-button
          type="button"
          class="btn-lg btn-success base-btn col-10 col-md-3 mx-lg-4"
          :to="{ name: 'OrderTransport', params: { yusoKbn: 0 } }"
        >
          通常輸送
        </md-button>
        <md-button
          type="button"
          class="btn-lg btn-success base-btn col-10 col-md-3 mx-lg-4"
          :to="{ name: 'OrderMeihenTransport', params: { yusoKbn: 1 } }"
        >
          名変輸送
        </md-button>
      </div>
    </section>

    <!-- 一時保存データ復元確認モーダル -->
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="showRestoreConfirm"
      md-title=""
      md-content="<strong>一時保存中の発注データがありますが反映しますか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="restoreTempData"
      @md-cancel="showDeleteConfirm = true"
    />

    <!-- 一時保存データ破棄確認モーダル -->
    <md-dialog-confirm
      class="new"
      :md-fullscreen="false"
      @md-opened="scroll('locked')"
      @md-closed="scroll('clear')"
      :md-active.sync="showDeleteConfirm"
      md-title=""
      md-content="<strong>一時保存データを破棄しますか？</strong>"
      md-confirm-text="はい"
      md-cancel-text="いいえ"
      @md-confirm="deleteTempData"
      @md-cancel="showDeleteConfirm = false"
    />
  </div>
</template>
<script>
import cloneDeep from 'lodash/cloneDeep'
import Mixin from '../mixin/Mixin'
import Navi from './Navi'
import {getTempData, removeTempData} from './utils/orderTempSave'

export default {
  name: 'Transport',
  mixins: [Mixin],
  components: {
    Navi,
  },
  data: () => ({
    showRestoreConfirm: false,
    showDeleteConfirm: false,
    tempData: null,
  }),
  created() {
    // 与信不可のユーザはホーム画面に遷移させる
    if (this.isYoshinFuka) return this.$router.push({ name: 'Home' })

    // 一時保存データのチェック
    this.checkTempData()
  },
  methods: {
    /** 一時保存データをチェックする */
    checkTempData() {
      const savedData = getTempData()
      if (savedData) {
        this.tempData = savedData
        this.showRestoreConfirm = true
      }
    },

    /** 一時保存データを復元する */
    restoreTempData() {
      if (!this.tempData) return

      const { type, data } = this.tempData

      // ルート名マップ
      const routes = {
        transport: ['OrderTransport', 'OrderMeihenTransport'],
        vehicle: ['OrderVehicle', 'OrderMeihenVehicle'],
      }

      // paramsの構築（データ構造が統一されたので、どちらも同じ処理）
      const form = cloneDeep(data)
      const yusoKbn = form.MEIHEN_FLG || 0
      const params = type === 'transport'
        ? { yusoKbn, form }
        : { form }

      this.$router.push({
        name: routes[type][yusoKbn],
        params,
      })
    },

    /** 一時保存データを削除する */
    deleteTempData() {
      removeTempData()
      this.tempData = null
      this.showDeleteConfirm = false
    },
  },
}
</script>
<style lang="sass" scoped>
@import '../../assets/css/logico2'
.page-btn-wrapper
  padding-top: 150px
  @include sp
    padding-top: 100px
.md-button
  @include sp
    margin: 6px auto
</style>



// WEBPACK FOOTER //
// src/components/order/Index.vue